export var MuiDivider = {
    styleOverrides: {
        root: {
            marginTop: 8,
            marginBottom: 8,
        },
        vertical: {
            marginTop: 0,
            marginBottom: 0,
        },
    },
};
